export const utilityDirections = ['Unknown', 'Import', 'Export', 'Import and export', 'Not applicable'];
export const waterArrangements = ['Unknown', 'Direct supply', 'Bulk supply', 'Submeter', 'Not applicable'];
export const utilityConnectivity = ['Communal broadband', 'CCTV', 'Door entry', 'Lift line', 'Alarm monitoring', 'BMS', 'Telemetry', 'Other'];
export const emptyUtilitySource = () => ({ state: 'Unknown', documentId: null, versionId: null, checksum: null, note: '' });
export const emptyUtilityDetails = () => ({ direction: 'Unknown', metering: 'Unknown', meterAssetIds: [], meterReadings: [], servedAssetIds: [], servedPremisesIds: [], parentSupplyId: null, waterArrangement: 'Unknown', drainageCharges: '', resale: 'Unknown', resaleBasis: '', tariffDetails: '', billingResponsibility: '', networkResponsibility: '', connectivity: [], previousBill: emptyUtilitySource(), finalBill: emptyUtilitySource(), balanceSource: emptyUtilitySource(), balanceAmount: '', balanceOn: null, comparison: 'Unknown', comparisonNote: '' });
export function utilityDetailsGaps(type, d) {
    const gaps = [];
    const meteredType = ['Electricity', 'Water / sewerage', 'Gas', 'Heat / cooling'].includes(type);
    if (meteredType && d.metering === 'Unknown')
        gaps.push('Metered or unmetered arrangement');
    if (meteredType && d.metering === 'Metered' && !d.meterAssetIds.length)
        gaps.push('Registered supply meters');
    if (type === 'Electricity' && d.direction === 'Unknown')
        gaps.push('Electricity import or export arrangement');
    // C-194: served assets and properties can follow the opening reading.
    if (meteredType && !d.tariffDetails.trim())
        gaps.push('Recorded tariff or charging basis');
    if (type === 'Water / sewerage') {
        if (d.waterArrangement === 'Unknown')
            gaps.push('Water supply arrangement');
        if (d.waterArrangement === 'Submeter' && !d.parentSupplyId)
            gaps.push('Parent bulk supply');
        if (!d.drainageCharges.trim())
            gaps.push('Drainage charging basis');
        if (d.resale === 'Unknown')
            gaps.push('Resident resale arrangement');
        if (d.resale === 'Yes' && (!d.resaleBasis.trim() || !d.billingResponsibility.trim()))
            gaps.push('Resale basis and billing responsibility');
    }
    if (type === 'Heat / cooling' && (!d.billingResponsibility.trim() || !d.networkResponsibility.trim()))
        gaps.push('Network maintenance and billing');
    if (type === 'Telecoms / data' && !d.connectivity.length)
        gaps.push('Connectivity purpose');
    for (const [key, label] of [['previousBill', 'Previous bill'], ['finalBill', 'Final bill'], ['balanceSource', 'Balance source']]) {
        const source = d[key];
        if (source.state === 'Unknown')
            gaps.push(label);
        else if (source.state === 'Not applicable' && !source.note.trim())
            gaps.push(label + ' exclusion basis');
        else if (source.state === 'Supplied' && (!source.documentId || !source.versionId || !source.checksum))
            gaps.push(label + ' exact source');
    }
    if (d.balanceSource.state !== 'Not applicable' && (!d.balanceAmount || !d.balanceOn))
        gaps.push('Reported balance and date');
    if (['Unknown', 'Awaiting information', 'Mismatch'].includes(d.comparison))
        gaps.push(d.comparison === 'Mismatch' ? 'Supply, transfer, bill or balance mismatch' : d.comparison === 'Awaiting information' ? 'Bill and balance comparison awaiting information' : 'Bill and balance comparison');
    if (['Matched', 'Not applicable', 'Mismatch'].includes(d.comparison) && !d.comparisonNote.trim())
        gaps.push('Comparison basis');
    return gaps;
}
//# sourceMappingURL=utility-details.js.map